import { FileText } from "lucide-react";
import { useParams } from "react-router-dom";

import { useGuideShare } from "@/lib/api/clinicianHooks";

export function GuideShareScreen() {
  const { token = "" } = useParams();
  const guide = useGuideShare(token);

  if (guide.isLoading) {
    return (
      <main className="min-h-screen bg-page text-ink grid place-items-center p-20">
        <p className="type-body-sm text-ink-muted">Opening your guide…</p>
      </main>
    );
  }
  if (guide.isError || !guide.data) {
    return (
      <main className="min-h-screen bg-page text-ink grid place-items-center p-20">
        <section className="max-w-[34rem] border border-line bg-raised p-24 text-center flex flex-col items-center gap-10">
          <FileText size={24} className="text-ink-muted" />
          <h1 className="type-heading-md">This guide link is unavailable</h1>
          <p className="type-body-sm text-ink-muted">
            It may have expired. Reply to your care team in Healthie and they
            can send a fresh copy.
          </p>
        </section>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-page text-ink flex flex-col">
      <header className="border-b border-line bg-raised px-14 md:px-24 py-12 flex items-center justify-between gap-10">
        <div className="min-w-0">
          <p className="type-label-xs text-ink-muted">SYSTEM CLINIC · GUIDE</p>
          <h1 className="type-heading-sm truncate">{guide.data.title}</h1>
        </div>
        <a
          href={guide.data.view_url}
          target="_blank"
          rel="noreferrer"
          className="type-label-sm border border-line px-10 py-7 hover:bg-sunken"
        >
          Open PDF
        </a>
      </header>
      <iframe
        title={guide.data.title}
        src={guide.data.view_url}
        className="w-full flex-1 min-h-[calc(100vh-5rem)] border-0"
      />
    </main>
  );
}
